export default function cx(...values) {
  return values.filter(Boolean).join(' ');
}
